import Checkbox from '../../Icons/getstarted/checkbox.svg'
import EmbedHubSpotForm from '../EmbedHubSpotForm'

export default function FreeResources() {
    const resources = [
        {
            title: 'Business Setup Checklist',
            desc: 'Step-by-step guide to setting up your real estate business.',
        },
        {
            title: 'Purchase Contract',
            desc: 'A template for purchasing and selling real estate.',
        },
        {
            title: 'Recommended Prospect Lists',
            desc: 'Our recommended lists to target the best potential contacts.',
        },
        {
            title: 'Assignment Contract',
            desc: 'A template for assigning your real estate contract to another buyer.',
        },
        {
            title: 'General List Criteria',
            desc: 'To help you identify and compile your list of potential contacts.',
        },
        {
            title: 'Agreement to Extend Closing Date',
            desc: 'A template to extend the closing  date of a purchase or sale.',
        },
        {
            title: 'FOIA Request Template',
            desc: 'To request tax liens and other public records using the Freedom of Information Act.',
        },
        {
            title: 'Deal Analysis Tool',
            desc: 'To help you evaluate the profitability of potential deals.',
        },
        {
            title: 'Phone Scripts',
            desc: 'To guide your conversations with prospects and leads.',
        },
    ]
    return (
        <div className="max-w-full w-[1200px] mx-auto my-16 relative">
            <img
                src="/assets/evergreen/banner/banner-dot.svg"
                className="absolute w-8 h-8 top-8 -left-8"
            />
            <img
                src="/assets/evergreen/banner/banner-dot.svg"
                className="absolute w-3 h-3 top-20 -left-12 opacity-75"
            />
            <div className="flex lg:flex-row lg:items-center flex-col m-4 lg:space-x-8 lg:space-y-0 space-y-8">
                <div className="lg:w-7/12 text-[#3F454F] space-y-4">
                    <div className="space-y-2">
                        <h3 className="olm-gradient-text lg:text-5xl/tight text-4xl/tight font-bold">
                            Free Resources to Kickstart or Boost Your REI
                            Business
                        </h3>
                        <p className="md:w-4/5 text-xl/tight">
                            Fill out the form to gain free access to our
                            essential real estate investor resources.
                        </p>
                    </div>
                    <p className="font-bold text-xl/snug">
                        Here&apos;s what you&apos;ll get for free:
                    </p>
                    <div className="grid md:grid-cols-2 gap-4">
                        {resources.map((resource, i) => (
                            <div className="flex flex-row space-x-2" key={i}>
                                <div className="w-1/12">
                                    <Checkbox />
                                </div>
                                <div className="w-11/12 text-base">
                                    <h4 className="font-bold">
                                        {resource.title}
                                    </h4>
                                    <p>{resource.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="lg:w-5/12">
                    <div className="bg-olm-gradient-diagonal-75 md:p-12 p-8 rounded-3xl text-white">
                        <EmbedHubSpotForm
                            region="na1"
                            portalId="21994206"
                            formId="3d4b3a62-7707-4df0-b132-821e4461abd5"
                            formName="Free Resources Form"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
